import { GET_ASSIGNMENTS_FAIL, GET_ASSIGNMENTS_SUCCESS, SET_SORTING_OPTIONS } from "../../actions/assignments/assignmentsAction";
import initialState from "./initialState";

export default function assignmentsReducer(state = initialState, action) {

    switch (action.type) {
        case GET_ASSIGNMENTS_SUCCESS: {

            const assignments = action.assignments.map((assignment) => {
                return {
                    assignmentId: assignment.assignmentId,
                    productName: assignment.productName,
                    name: assignment.name,
                    status: assignment.status,
                    assignmentType: assignment.assignmentType,
                    dueDate: assignment.dueDate,
                    startDate: assignment.startDate,
                    url: assignment.url,
                };
            });
            return {...state, assignments};
        }

        case GET_ASSIGNMENTS_FAIL: {
            return {...state, errorMessage: "There was an error retrieving all assignments."};
        }

        case SET_SORTING_OPTIONS: {
            return {...state, sortOptions: action.sortOptions};
        }

        default:
            return state;
    }
}
